import React, { useEffect, useState } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import SelectCities from '../../../../../components/FormInputs/SelectCities';
import SelectState from '../../../../../components/FormInputs/SelectState';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import API from '../../../../../api/axios';
import GridOnOutlinedIcon from '@material-ui/icons/GridOnOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';

const UploadExcellForWayBills = React.memo((props) => {
  const [state, setState] = useState({});
  const handleSelectCity = (city) => {
    setState({ ...state, city });
  };
  const handleSelectState = (localState) => {
    setState({ ...state, localState });
  };
  const handleSelectFile = (e) => {
    const file = e.target.files[0];
    setState({ ...state, file: !!file ? file : null });
  };
  const handleUploadAndSave = async () => {
    if (!!state.city && !!state.file) {
      try {
        setState({ ...state, uploading: true });
        let data = new FormData();
        data.set('origin', state.city.value);
        data.set('file', state.file);
        const response = await API.post(
          `/api/v1/admin/cityfleet/price/upload/excel`,
          data,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
          }
        );
        props.showMessage(1, '', '', 'فایل با موفقیت آپلود و ذخیره گردید');
        setState({ ...state, uploading: false });
      } catch (error) {
        console.error(error);
        props.showMessage(
          2,
          '',
          '',
          'خطایی در هنگام بارگزاری و ذخیره رخ داده است'
        );
      }
    } else {
      props.showMessage(
        2,
        '',
        '',
        'شهر و فایل اکسل مربوط به شهر بایستی انتخاب شود'
      );
    }
  };

  return (
    <FullCard
      title={props.config.name}
      category="فایل اکسل حاوی کرایه حمل همه شهرها را از نمونه ارایه دانلود و پس از تکمیل
            کرایه ها بر مبنای ناوگان آنرااز طریق فرم زیر در سیستم آپلود نمایید."
    >
      <Grid container direction="column" alignItems="stretch" spacing={1}>
        <Grid item>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <SelectState
                localState={!!state.localState ? state.localState : null}
                isMulti={false}
                onSelect={handleSelectState}
                placeholder="استان"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SelectCities
                isMulti={false}
                localState={!!state.localState ? state.localState.value : null}
                placeholder="شهر"
                onSelect={handleSelectCity}
                isDest={false}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ textAlign: 'center' }}>
          <Button
            variant="contained"
            component="label"
            startIcon={<GridOnOutlinedIcon />}
            disabled={state.uploading ? true : false}
          >
            انتخاب فایل اکسل
            <input
              type="file"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              onChange={handleSelectFile}
              style={{ display: 'none' }}
            />
          </Button>
        </Grid>
        {
          <Grid item style={{ textAlign: 'center' }}>
            {state.uploading ? <CircularProgress color="secondary" /> : null}
          </Grid>
        }
        <Grid item>
          <Button
            color="secondary"
            variant="contained"
            fullWidth
            size="large"
            onClick={handleUploadAndSave}
            disabled={state.uploading ? true : false}
          >
            آپلود و ذخیره
          </Button>
        </Grid>
      </Grid>
    </FullCard>
  );
});

export default UploadExcellForWayBills;
